import { useGetPatientsVisited } from '@vindr/services/actions/patient.action';
import { INIT_PAGINATION } from '@vindr/services/constants/common.constant';
import { PaginationProps } from '@vindr/services/interfaces';
import onPaginationChange from '@vindr/utils/state/onPaginationChange';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useImmer } from 'use-immer';
import Table, { VindrTableProps } from '../../../../ui/Table';
import Filter from './PatientFilter';
import usePatientColumns from './usePatientColumns';

const PatientSearch = ({ initFilters, onSave, onCancel }) => {
  const { t } = useTranslation('Vindoc');
  const columns = usePatientColumns();
  const [params, setParams] = useState(initFilters);
  const [pagination, setPagination] = useImmer<PaginationProps>(INIT_PAGINATION);
  const query = useGetPatientsVisited({
    ...params,
    limit: pagination.size,
    offset: (pagination.page - 1) * pagination.size,
  });
  const count = query?.data?.count;
  const patients = query?.data?.data || [];
  const isLoading = query?.isLoading;
  const isFetching = query?.isFetching;
  const refetch = query?.refetch;

  const [isRefetch, setIsRefetch] = useState(false);
  useEffect(() => {
    if (!isFetching) {
      // After fetching, set isRefetch to false;
      setIsRefetch(false);
    }
  }, [isFetching]);

  const forceSearch = (params) => {
    setParams(params);
    // Set refetch to true only when force search
    setIsRefetch(true);
    refetch?.();
  };

  return (
    <div className="flex flex-col">
      <Filter
        initFilters={initFilters}
        onChange={(p) => {
          setParams(p);
        }}
        forceSearch={forceSearch}
      />
      <Table
        columns={columns}
        dataSource={patients}
        scroll={{ y: 500 }}
        rowKey="id"
        isLoading={isLoading || isRefetch}
        wrapperClassName="h-auto"
        style={{ cursor: 'pointer' }}
        count={count}
        pagination={count < pagination.size ? null : pagination}
        onPaginationChange={(p: VindrTableProps['pagination']) => {
          setPagination((draft) => onPaginationChange(draft, p));
        }}
        onRow={(record) => {
          return {
            onDoubleClick: (event) => {
              event.stopPropagation();
              event.preventDefault();
              /* if (event?._targetInst?.elementType === 'input') {
                // handle action doubleClick to checkbox
                return;
              } */
              if ((event?.target as HTMLInputElement)?.tagName === 'INPUT') {
                // handle action doubleClick to checkbox
                return;
              }

              onSave(record);
            },
          };
        }}
      />
      <div className="footer mt-3 flex justify-end">
        <Button onClick={onCancel}>{t('Cancel')}</Button>
      </div>
    </div>
  );
};

export default PatientSearch;
